/* XBavly product reviews: horizontal slider on desktop and mobile. Replace xb-reviews.js. */
class XBReviews {
  constructor(config = {}) {
    this.api = String(config.api ?? "").replace(/\/$/, "");
    this.productId = String(config.productId ?? "");
    this.productHandle = String(config.productHandle ?? "");
    this.productTitle = String(config.productTitle ?? "");
    this.locale = config.locale === "ar" ? "ar" : "en";
    this.isAr = this.locale === "ar";
    this.root = document.getElementById("xb-reviews");
    this.customer = {
      loggedIn: Boolean(config.customer?.loggedIn),
      name: String(config.customer?.name ?? ""),
      email: String(config.customer?.email ?? "")
    };
    this.selectedRating = 5;
    this.sortBy = "newest";
    this.reviewSliderIndex = 0;
    this.reviewSliderCleanup = null;
    this.modalCloseTimer = null;
    this.modal = null;
    this.isSubmitting = false;
    this.reviewReminder = null;
    this.reviewTarget = null;
    this.stickyBuyBar = null;
    this.stickyBuyObserver = null;
    this.stickyBuyResizeObserver = null;
    this.data = {
      stats: {
        count: 0,
        average: 0
      },
      breakdown: [],
      reviews: []
    };
    this.text = this.getText();
  }
  getText() {
    return this.isAr
      ? {
          title: "تقييمات العملاء",
          writeReview: "اكتب تقييمك",
          basedOn: "بناءً على",
          reviews: "تقييم",
          noReviews: "لا توجد تقييمات بعد. كن أول من يقيّم هذا المنتج.",
          name: "اسمك",
          email: "البريد الإلكتروني",
          reviewTitle: "اكتب عنوانًا لتقييمك",
          reviewBody: "شاركنا تجربتك وساعد اللاعبين الآخرين في اتخاذ القرار...",
          submit: "إرسال التقييم",
          cancel: "إلغاء",
          sortBy: "ترتيب حسب:",
          newest: "الأحدث",
          oldest: "الأقدم",
          highest: "الأعلى تقييمًا",
          lowest: "الأقل تقييمًا",
          helpful: "مفيد",
          success: "شكرًا لك! تقييمك قيد المراجعة قبل النشر.",
          error: "حدث خطأ، حاول مرة أخرى."
        }
      : {
          title: "Customer Reviews",
          writeReview: "Write a Review",
          basedOn: "Based on",
          reviews: "reviews",
          noReviews: "No reviews yet. Be the first to review this product.",
          name: "Your Name",
          email: "Email Address",
          reviewTitle: "Give your review a title",
          reviewBody: "Tell us about your experience...",
          submit: "Submit Review",
          cancel: "Cancel",
          sortBy: "Sort by:",
          newest: "Most Recent",
          oldest: "Oldest",
          highest: "Highest Rating",
          lowest: "Lowest Rating",
          helpful: "Helpful",
          success: "Thanks! Your review is awaiting approval.",
          error: "Something went wrong. Please try again."
        };
  }
  async init() {
    if (
      !this.root ||
      !this.productId ||
      !this.api ||
      !window.XBReviewsAPI ||
      !window.XBReviewsUI
    ) {
      return;
    }
    window.XBReviewsAPI.init(this.api);
    this.root.className =
      `xb-reviews-root ${this.isAr ? "xb-rtl" : "xb-ltr"}`;
    this.renderLoading();
    await this.loadReviews();
this.render();
    this.bindEvents();
  }
  async loadReviews() {
    try {
      const data = await window.XBReviewsAPI.getReviews(this.productId);
      if (!data?.success) {
        return;
      }
      this.data = {
        stats: {
          count: Math.max(0, Number(data.stats?.count) || 0),
          average: Math.min(
            5,
            Math.max(0, Number(data.stats?.average) || 0)
          )
        },
        breakdown: Array.isArray(data.breakdown)
          ? data.breakdown
          : [],
        reviews: Array.isArray(data.reviews)
          ? data.reviews
          : []
      };
    } catch (error) {
      console.error("XB Reviews load error:", error);
    }
  }
  async loadReviewReminder() {
      const snoozedUntil = Number(
    localStorage.getItem(
      "xb_review_reminder_snoozed_until"
    ) || 0
  );
  if (snoozedUntil > Date.now()) {
    this.reviewReminder = null;
    return;
  }
  if (
    !this.customer.loggedIn ||
    !this.customer.email
  ) {
    this.reviewReminder = null;
    return;
  }
  try {
    const data =
      await window.XBReviewsAPI.getReviewReminder(
        this.customer.email
      );
    this.reviewReminder =
      data?.success
        ? data.reminder
        : null;
  } catch (error) {
    console.error(
      "Review reminder error:",
      error
    );
    this.reviewReminder = null;
  }
}
  renderLoading() {
    if (!this.root) return;
    this.root.innerHTML = `
      <section class="xb-reviews xb-reviews-loading" aria-busy="true" aria-label="${this.isAr ? "جارٍ تحميل التقييمات" : "Loading reviews"}">
        <div class="xb-review-hero">
          <div class="xb-review-score-box">
            <span class="xb-skeleton xb-skeleton-kicker"></span>
            <span class="xb-skeleton xb-skeleton-score"></span>
            <div class="xb-score-details">
              <span class="xb-skeleton xb-skeleton-stars"></span>
              <span class="xb-skeleton xb-skeleton-based"></span>
            </div>
          </div>
          <div class="xb-breakdown">
            <span class="xb-skeleton xb-skeleton-breakdown-title"></span>
            ${Array.from({ length: 5 }, () => `
              <div class="xb-review-skeleton-break-row">
                <span class="xb-skeleton xb-skeleton-break-star"></span>
                <span class="xb-skeleton xb-skeleton-break-bar"></span>
                <span class="xb-skeleton xb-skeleton-break-count"></span>
              </div>
            `).join("")}
          </div>
        </div>
        <div class="xb-review-toolbar">
          <div class="xb-sort-bar">
            <span class="xb-skeleton xb-skeleton-sort-label"></span>
            <span class="xb-skeleton xb-skeleton-sort-select"></span>
          </div>
          <span class="xb-skeleton xb-skeleton-write-button"></span>
        </div>
        <div class="xb-review-list" data-review-count="2" dir="${this.isAr ? 'rtl' : 'ltr'}">
          ${Array.from({ length: 2 }, () => this.renderReviewSkeleton()).join("")}
        </div>
      </section>
    `;
  }
  renderReviewSkeleton() {
    return `
      <article class="xb-review-card xb-review-skeleton-card" aria-hidden="true">
        <div class="xb-review-user">
          <span class="xb-skeleton xb-skeleton-avatar"></span>
          <div class="xb-review-main">
            <span class="xb-skeleton xb-skeleton-name"></span>
            <span class="xb-skeleton xb-skeleton-card-stars"></span>
          </div>
        </div>
        <span class="xb-skeleton xb-skeleton-review-title"></span>
        <span class="xb-skeleton xb-skeleton-review-line"></span>
        <span class="xb-skeleton xb-skeleton-review-line xb-skeleton-review-line-short"></span>
        <div class="xb-review-footer">
          <span class="xb-skeleton xb-skeleton-helpful"></span>
          <span class="xb-skeleton xb-skeleton-date"></span>
        </div>
      </article>
    `;
  }
render() {
  if (!this.root) return;
  this.reviewSliderCleanup?.();
  this.reviewSliderCleanup = null;
  const sortedReviews = this.getSortedReviews();
  const ctx = {
    data: {
      ...this.data,
      reviews: sortedReviews
    },
    text: this.text,
    locale: this.locale,
    isAr: this.isAr,
    reviewReminder: this.reviewReminder,
    sortBy: this.sortBy,
    customer: this.customer
  };
  this.root.innerHTML = window.XBReviewsUI.createWidget(ctx);
  // Modal now lives on <body>, outside the product section's stacking context
  this.modal = window.XBReviewsUI.mountModal(ctx);
}
  getSortedReviews() {
    const reviews = Array.isArray(this.data.reviews)
      ? [...this.data.reviews]
      : [];
    const getTime = review => {
      const time = new Date(review?.created_at).getTime();
      return Number.isFinite(time) ? time : 0;
    };
    const getRating = review => {
      return Math.min(
        5,
        Math.max(0, Number(review?.rating) || 0)
      );
    };
    switch (this.sortBy) {
      case "oldest":
        return reviews.sort(
          (a, b) => getTime(a) - getTime(b)
        );
      case "highest":
        return reviews.sort(
          (a, b) => getRating(b) - getRating(a)
        );
      case "lowest":
        return reviews.sort(
          (a, b) => getRating(a) - getRating(b)
        );
      case "newest":
      default:
        return reviews.sort(
          (a, b) => getTime(b) - getTime(a)
        );
    }
  }
  bindEvents() {
    if (!this.root) return;
    this.bindReviewSlider();
const modal = this.modal;
const form = modal?.querySelector(".xb-review-form");
const starButtons = modal
  ? modal.querySelectorAll(".xb-star-picker button")
  : [];
    const sortSelect = this.root.querySelector(
      ".xb-sort-select"
    );
    const reminderPopup = document.querySelector(
  ".xb-review-reminder-popup"
);
this.setupReviewReminderStickyOffset(
  reminderPopup
);
const reminderCloseButtons =
  document.querySelectorAll(
    ".xb-review-reminder-close, .xb-review-reminder-later"
  );
    let previousFocus = null;
    const openModal = () => {
      previousFocus = document.activeElement;
      this.selectedRating = 5;
      this.paintStarPicker(starButtons);
      if (!modal) return;
      if (this.modalCloseTimer) {
        clearTimeout(this.modalCloseTimer);
        this.modalCloseTimer = null;
      }
      reminderPopup?.classList.add("is-hidden");
      modal.hidden = false;
      document.body.classList.add("xb-modal-open");
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          modal.classList.add("is-open");
          modal.querySelector(".xb-modal-x")?.focus();
        });
      });
    };
    const closeModal = () => {
      if (this.isSubmitting) return;
      if (!modal) return;
      modal.classList.remove("is-open");
      if (this.modalCloseTimer) {
        clearTimeout(this.modalCloseTimer);
      }
      this.modalCloseTimer = setTimeout(() => {
        modal.hidden = true;
        document.body.classList.remove("xb-modal-open");
        this.modalCloseTimer = null;
        previousFocus?.focus();
      }, 420);
    };
    this.root
  .querySelectorAll(
    ".xb-open-modal:not(.xb-review-reminder-write)"
  )
  .forEach(button => {
    button.addEventListener("click", () => {
      const reminderMatchesCurrentProduct =
        this.reviewReminder &&
        String(this.reviewReminder.product_id) ===
          String(this.productId);
      this.reviewTarget = reminderMatchesCurrentProduct
        ? this.reviewReminder
        : null;
      openModal();
    });
  });
const reminderWriteButton = document.querySelector(
  ".xb-review-reminder-write"
);
reminderWriteButton?.addEventListener("click", () => {
  this.reviewTarget = this.reviewReminder;
  openModal();
});
modal
  ?.querySelectorAll(".xb-close-modal")
  .forEach(button => {
    button.addEventListener("click", closeModal);
  });
      reminderCloseButtons.forEach(button => {
  button.addEventListener("click", () => {
    reminderPopup?.classList.add("is-hidden");
    localStorage.setItem(
      "xb_review_reminder_snoozed_until",
      String(
        Date.now() +
        7 * 24 * 60 * 60 * 1000
      )
    );
  });
});
    modal?.addEventListener("keydown", event => {
      if (event.key === "Escape") closeModal();
      if (event.key !== "Tab") return;
      const fields = [...modal.querySelectorAll("button:not(:disabled), input:not([type=hidden]), textarea, select")];
      const first = fields[0], last = fields[fields.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
    });
    starButtons.forEach(button => {
      button.addEventListener("click", () => {
        const rating = Number(button.dataset.rating);
        this.selectedRating = Math.min(
          5,
          Math.max(1, rating || 1)
        );
        this.paintStarPicker(starButtons);
      });
    });
    sortSelect?.addEventListener("change", event => {
      const allowedSorts = [
        "newest",
        "oldest",
        "highest",
        "lowest"
      ];
      const requestedSort = String(event.target.value);
      this.sortBy = allowedSorts.includes(requestedSort)
        ? requestedSort
        : "newest";
      this.reviewSliderIndex = 0;
      this.render();
      this.bindEvents();
    });
    this.root
      .querySelectorAll(".xb-helpful-btn")
      .forEach(button => {
        button.addEventListener("click", async () => {
          const reviewId = String(
            button.dataset.reviewId ?? ""
          ).trim();
          if (
  !reviewId ||
  button.disabled ||
  button.classList.contains("is-voted")
) {
  return;
}
          button.disabled = true;
          try {
            const data =
              await window.XBReviewsAPI.helpfulReview(
                reviewId
              );
            if (!data?.success) {
              button.disabled = false;
              return;
            }
            const helpfulCount = Math.max(
              0,
              Number(data.helpful_count) || 0
            );
            const countSpan = button.querySelector("span");
            if (countSpan) {
              countSpan.textContent = String(helpfulCount);
            }
            const review = this.data.reviews.find(row => String(row.id) === reviewId);
            if (review) { review.helpful_count = helpfulCount; review.user_has_voted = true; }
            button.classList.add("is-voted");
button.setAttribute("aria-pressed", "true");
button.disabled = true;
          } catch (error) {
            console.error("Helpful vote error:", error);
            button.disabled = false;
          }
        });
      });
    form?.addEventListener("submit", event => {
      this.submitReview(event);
    });
  }
  bindReviewSlider() {
    this.reviewSliderCleanup?.();
    this.reviewSliderCleanup = null;
    const track = this.root.querySelector("#xb-review-slider-track");
    if (!track) return;
    const slides = [...track.querySelectorAll(".xb-review-card")];
    if (!slides.length) return;
    const slider = track.closest(".xb-review-slider");
    const controls = slider.querySelector(".xb-review-slider-controls");
    const previous = slider.querySelector(".xb-review-slider-prev");
    const next = slider.querySelector(".xb-review-slider-next");
    const count = slider.querySelector(".xb-review-slider-count");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let frame = null;
    let settleFrame = null;
    let settling = false;
    const visibleCount = () => {
      const style = getComputedStyle(track);
      const gap = parseFloat(style.columnGap) || 0;
      const width = track.clientWidth
        - (parseFloat(style.paddingInlineStart) || 0)
        - (parseFloat(style.paddingInlineEnd) || 0);
      const cardWidth = slides[0].getBoundingClientRect().width;
      return Math.min(slides.length, Math.max(1,
        Math.floor((width + gap + 1) / (cardWidth + gap))
      ));
    };
    const maxIndex = () => Math.max(0, slides.length - visibleCount());
    const clampIndex = index => Math.min(maxIndex(), Math.max(0, index));
    const updateControls = () => {
      const index = clampIndex(this.reviewSliderIndex);
      const visible = visibleCount();
      const canScroll = track.scrollWidth > track.clientWidth + 1;
      this.reviewSliderIndex = index;
      if (previous) previous.disabled = !canScroll || index === 0;
      if (next) next.disabled = !canScroll || index === maxIndex();
      if (controls) controls.hidden = !canScroll;
      if (canScroll) track.setAttribute("tabindex", "0");
      else track.removeAttribute("tabindex");
      const last = Math.min(slides.length, index + visible);
      const range = visible > 1 ? `${index + 1}–${last}` : String(index + 1);
      const label = `${range} / ${slides.length}`;
      if (count && count.textContent !== label) count.textContent = label;
    };
    // Physical card positions work for both LTR and RTL scroll containers.
    const slideOffset = card => {
      const trackRect = track.getBoundingClientRect();
      const cardRect = card.getBoundingClientRect();
      const padding = parseFloat(getComputedStyle(track).paddingInlineStart) || 0;
      return this.isAr
        ? cardRect.right - (trackRect.right - padding)
        : cardRect.left - (trackRect.left + padding);
    };
    const goTo = (index, animate = true) => {
      this.reviewSliderIndex = clampIndex(index);
      const behavior = animate && !reducedMotion.matches ? "smooth" : "instant";
      if (this.reviewSliderIndex === 0) {
        track.scrollTo({ left: 0, behavior });
      } else {
        track.scrollBy({ left: slideOffset(slides[this.reviewSliderIndex]), behavior });
      }
      updateControls();
    };
    const cancelSettling = () => {
      if (settleFrame !== null) cancelAnimationFrame(settleFrame);
      settleFrame = null;
      settling = false;
      track.style.removeProperty("scroll-snap-type");
    };
    // Reset native scroll restoration after rendering or changing viewport size.
    const settleAt = index => {
      cancelSettling();
      if (frame !== null) cancelAnimationFrame(frame);
      frame = null;
      settling = true;
      track.style.setProperty("scroll-snap-type", "none");
      goTo(index, false);
      settleFrame = requestAnimationFrame(() => {
        settleFrame = requestAnimationFrame(() => {
          settleFrame = null;
          goTo(index, false);
          track.style.removeProperty("scroll-snap-type");
          goTo(index, false);
          settling = false;
        });
      });
    };
    const navigate = index => {
      cancelSettling();
      goTo(index);
    };
    const onScroll = () => {
      if (settling || frame !== null) return;
      frame = requestAnimationFrame(() => {
        frame = null;
        if (settling) return;
        let nearest = 0;
        let distance = Infinity;
        const maximum = maxIndex();
        slides.forEach((card, index) => {
          if (index > maximum) return;
          const offset = Math.abs(slideOffset(card));
          if (offset < distance) { nearest = index; distance = offset; }
        });
        this.reviewSliderIndex = nearest;
        updateControls();
      });
    };
    const onPrevious = () => navigate(this.reviewSliderIndex - 1);
    const onNext = () => navigate(this.reviewSliderIndex + 1);
    const onKeyDown = event => {
      if (event.target !== track) return;
      let index;
      if (event.key === "ArrowRight") index = this.reviewSliderIndex + (this.isAr ? -1 : 1);
      else if (event.key === "ArrowLeft") index = this.reviewSliderIndex + (this.isAr ? 1 : -1);
      else if (event.key === "Home") index = 0;
      else if (event.key === "End") index = maxIndex();
      else return;
      event.preventDefault();
      navigate(index);
    };
    track.addEventListener("scroll", onScroll, { passive: true });
    track.addEventListener("keydown", onKeyDown);
    previous?.addEventListener("click", onPrevious);
    next?.addEventListener("click", onNext);
    const onResize = () => settleAt(this.reviewSliderIndex);
    const resizeObserver = typeof ResizeObserver !== "undefined"
      ? new ResizeObserver(onResize)
      : null;
    if (resizeObserver) resizeObserver.observe(track);
    else window.addEventListener("resize", onResize);
    settleAt(this.reviewSliderIndex);
    this.reviewSliderCleanup = () => {
      if (frame !== null) cancelAnimationFrame(frame);
      cancelSettling();
      resizeObserver?.disconnect();
      window.removeEventListener("resize", onResize);
      track.removeEventListener("scroll", onScroll);
      track.removeEventListener("keydown", onKeyDown);
      previous?.removeEventListener("click", onPrevious);
      next?.removeEventListener("click", onNext);
    };
  }
  setupReviewReminderStickyOffset(reminderPopup) {
  if (!reminderPopup) return;
  if (this.stickyBuyObserver) {
    this.stickyBuyObserver.disconnect();
    this.stickyBuyObserver = null;
  }
  if (this.stickyBuyResizeObserver) {
    this.stickyBuyResizeObserver.disconnect();
    this.stickyBuyResizeObserver = null;
  }
  this.stickyBuyBar = document.querySelector(
    "[class*='ai-sticky-buy-now-']"
  );
  if (!this.stickyBuyBar) {
    reminderPopup.classList.remove(
      "xb-sticky-visible"
    );
    reminderPopup.style.setProperty(
      "--xb-sticky-buy-height",
      "0px"
    );
    return;
  }
  let animationFrame = null;
  const updateOffset = () => {
    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
    }
    animationFrame = requestAnimationFrame(() => {
      const rect =
        this.stickyBuyBar.getBoundingClientRect();
      const isVisible =
  this.stickyBuyBar.classList.contains("visible") ||
  this.stickyBuyBar.getAttribute("aria-hidden") === "false";
      const stickyHeight = isVisible
        ? Math.ceil(rect.height)
        : 0;
      reminderPopup.style.setProperty(
        "--xb-sticky-buy-height",
        `${stickyHeight}px`
      );
      reminderPopup.classList.toggle(
        "xb-sticky-visible",
        isVisible
      );
      animationFrame = null;
    });
  };
  this.stickyBuyObserver =
    new MutationObserver(updateOffset);
  this.stickyBuyObserver.observe(
    this.stickyBuyBar,
    {
      attributes: true,
      attributeFilter: [
        "class",
        "style",
        "aria-hidden"
      ]
    }
  );
  if (typeof ResizeObserver !== "undefined") {
    this.stickyBuyResizeObserver =
      new ResizeObserver(updateOffset);
    this.stickyBuyResizeObserver.observe(
      this.stickyBuyBar
    );
  }
  updateOffset();
}
  paintStarPicker(starButtons) {
    starButtons.forEach(button => {
      const rating = Number(button.dataset.rating) || 0;
      button.classList.toggle(
        "active",
        rating <= this.selectedRating
      );
    });
  }
  async submitReview(event) {
    event.preventDefault();
    if (this.isSubmitting) return;
    const form = event.currentTarget;
    const message = form.querySelector(".xb-form-message");
    const submitButton = form.querySelector(
      'button[type="submit"]'
    );
    if (!message || !submitButton) {
      return;
    }
    const titleInput = form.elements.namedItem(
      "review_title"
    );
    const bodyInput = form.elements.namedItem(
      "review_body"
    );
    const nameInput = form.elements.namedItem(
      "customer_name"
    );
    const emailInput = form.elements.namedItem(
      "customer_email"
    );
    const customerName = this.customer.loggedIn
      ? this.customer.name.trim()
      : String(nameInput?.value ?? "").trim();
    const customerEmail = this.customer.loggedIn
      ? this.customer.email.trim()
      : String(emailInput?.value ?? "").trim();
    const reviewTitle = String(
      titleInput?.value ?? ""
    ).trim();
    const reviewBody = String(
      bodyInput?.value ?? ""
    ).trim();
    this.selectedRating = Math.min(
      5,
      Math.max(1, Number(this.selectedRating) || 5)
    );
    message.textContent = "";
    if (customerName.length < 3 || reviewBody.length < 5) {
      message.textContent = this.text.error;
      return;
    }
    const targetProductId =
  this.reviewTarget?.product_id ??
  this.productId;
const targetProductHandle =
  this.reviewTarget?.product_handle ??
  this.productHandle;
const targetProductTitle =
  this.reviewTarget?.product_title ??
  this.productTitle;
const payload = {
  product_id: String(targetProductId),
  product_handle: String(targetProductHandle),
  product_title: String(targetProductTitle),
  review_request_id:
    this.reviewTarget?.id ?? null,
  customer_name: customerName,
  customer_email: customerEmail,
  rating: this.selectedRating,
  review_title: reviewTitle,
  review_body: reviewBody,
  language: this.locale
};
    this.isSubmitting = true;
    submitButton.disabled = true;
    try {
      const data =
        await window.XBReviewsAPI.submitReview(payload);
      message.textContent =
        data?.message ||
        (data?.success
          ? this.text.success
          : this.text.error);
      if (data?.success) {
  this.reviewReminder = null;
  this.reviewTarget = null;
  form.reset();
  this.selectedRating = 5;
  this.paintStarPicker(
    form.querySelectorAll(
      ".xb-star-picker button"
    )
  );
document.body.classList.remove("xb-modal-open");
if (this.modalCloseTimer) clearTimeout(this.modalCloseTimer);
this.modalCloseTimer = null;
  await this.loadReviews();
  this.render();
  this.bindEvents();
}
    } catch (error) {
      console.error("XB Reviews submit error:", error);
      message.textContent = this.text.error;
    } finally {
      this.isSubmitting = false;
      submitButton.disabled = false;
    }
  }
}
const initializeXBReviews = () => {
  if (!window.XB_REVIEWS) return;
  const root = document.getElementById("xb-reviews");
  if (!root || root.dataset.xbInitialized) return;
  root.dataset.xbInitialized = "true";
  const instance = new XBReviews(window.XB_REVIEWS);
  instance.init();
};
if (document.readyState === "loading") {
  document.addEventListener(
    "DOMContentLoaded",
    initializeXBReviews,
    { once: true }
  );
} else {
  initializeXBReviews();
}
